import React, {FunctionComponent, useEffect, useState} from "react"
import TmsDashboard from "./components/TmsDashboard"
import ComponentWrapper from "../../common/components/ComponentWrapper"
import {useModal} from "@murphy-frontend/web-core/contexts/ModalContext"
import {ModalConfiguration} from "@murphy-frontend/web-core/components/Modal"
import {useNavigate, useParams} from "react-router-dom"
import {useGetRequirementDashboard} from "./api/queries"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import CircleProgress from "@murphy-frontend/web-core/components/CircleProgress"
import Button from "@murphy-frontend/web-core/components/Button"
import {IconContext} from "react-icons"
import {TbEdit} from "react-icons/tb"
import {useCustomer} from "../../common/contexts/CustomerContext"
import {useUserPreferences} from "../../common/contexts/UserPreferencesContext"
import {FaQuestion} from "react-icons/fa6"
import {CiFileOn} from "react-icons/ci"

interface BannerProps {
	image: any
	title: string
	body1: string
	body2: string
	body3: string
	customStyles?: any
	onRemind: () => void,
	onStart: () => void
}

const styles = {
	container: {
		width: "90rem",
		backgroundColor: "white",
		height: "15rem",
		padding: 20,
		borderWidth: "1px",
		border: "solid",
		marginBottom: 20,
		borderColor: "#00A098",
		overflow: "hidden"
	},
	img: {
		width: 30,
		height: 30,
		marginRight: 20
	},
	title: {
		fontWeight: "bold",
		fontSize: "16px"
	}
}

const Banner: FunctionComponent<BannerProps> = ({image, title, body1, body2, body3, customStyles = {}, onRemind, onStart}) => {
	const onRemindLater = () => {
		onRemind()
		sessionStorage.setItem("showBanner", "false")
	}
	return (
		<div style={{...styles.container, ...customStyles}}>
			<div style={{display: "flex", flexDirection: "column"}}>
				<div style={{display: "flex", flexDirection: "row", marginBottom: 10, alignItems: "center"}}>
					<img src={image} style={styles.img} />
					<label style={styles.title}>{title}</label>
				</div>
				<label style={{color: "#7F7F7F", marginBottom: 10}}>{body1}</label>
				<label style={{color: "#7F7F7F", marginBottom: 10}}>{body2}</label>
				<label style={{color: "#7F7F7F", marginBottom: 10}}>{body3}</label>
				<div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20}}>
					<label
						style={{textDecorationLine: "underline", marginRight: 20, color: "#7F7F7F", cursor: "pointer"}}
						onClick={onRemindLater}
					>
						Remind me later
					</label>
					<Button buttonStyle='btn--primary' onClick={onStart}>
						Start Assessment
					</Button>
				</div>
			</div>
		</div>
	)
}
function tmsStartPage() {
	const navigate = useNavigate()
	const {customer} = useCustomer()
	const {customerId} = useParams()
	const {translations} = useUserPreferences()
	const {data: dashboard, isLoading, isPending} = useGetRequirementDashboard(customerId)

	const {openModal, closeModal} = useModal()
	const showBannerOnTop = sessionStorage.getItem("showBanner")
	const [showBanner, setShowBanner] = useState<boolean>(showBannerOnTop === "true")
	const [remindClick, setRemindClick] = useState<boolean>(false)

	const showTutorial = () => {
		const modalConf: ModalConfiguration = {
			okCallback: () => {
				console.log("onclick")
			},
			onCloseModal: () => {
				setShowBanner(true)
				sessionStorage.setItem("showBanner", "true")
				sessionStorage.setItem("skipModal", "true")
			},
			type: "tutorial",
			centerContent: false,
			body: (
				<div>
					<div style={{display: "flex", flexDirection: "row"}}>
						<div
							style={{
								height: "30rem",
								justifyContent: "center",
								alignItems: "center",
								overflow: "hidden"
							}}
						>
							<img src={require("../../assets/img/tms.png")} style={{height: "30rem"}} />
						</div>
						<div
							style={{
								width: "30rem",
								paddingLeft: 20,
								display: "flex",
								flexDirection: "column",
								paddingRight: 30,
								paddingTop: 60
							}}
						>
							<label style={{marginBottom: 5, fontSize: 16, fontWeight: "bold", color: "#00726C"}}>
								The Crisis Framework (TCF)
							</label>
							<label style={{marginBottom: 10, fontSize: 24, fontWeight: "bold"}}>
								Structure Your Crisis Response with the TCF
							</label>
							<label style={{marginBottom: 10, color: "#626262"}}>
								The Crisis Framework (TCF) helps your team evaluate and improve crisis readiness — with
								clear goals and a personalised action plan.
							</label>
							<label style={{marginBottom: 10, color: "#626262"}}>
								It measures your teazm’s capabilities across four key areas:People, Communication,
								Tools, and Organisation.
							</label>
							<label style={{color: "#626262"}}>
								You’ll get a baseline view and know exactly where to focus next.
							</label>
							<div style={{width: "20rem", alignSelf: "flex-end", marginTop: 30}}>
								<Button
									buttonStyle='btn--primary'
									onClick={() => {
										closeModal()
										setShowBanner(true)
										sessionStorage.setItem("showBanner", "true")
										sessionStorage.setItem("skipModal", "true")
									}}
								>
									Explore TCF View
								</Button>
							</div>
						</div>
					</div>
				</div>
			),
			hideButton: true,
			position: "center"
		}
		openModal(modalConf)
	}
	useEffect(() => {
		const skipModal = sessionStorage.getItem("skipModal")
		if (!skipModal && customer.IsFreemium) {
			showTutorial()
		}
	}, [])

	if (isLoading || isPending) {
		return (
			<ComponentWrapper active={3} subMenuActive={1}>
				<div className='spinner-container-global-center'>
					<Spinner />
				</div>
			</ComponentWrapper>
		)
	}

	let percent = Math.round((dashboard.averageScore / dashboard.GoalLevel) * 100)
	if (percent > 100) percent = 100
	if (!dashboard.GoalLevel) percent = 0

	return (
		<ComponentWrapper active={3} subMenuActive={1}>
			{showBanner && customer.IsFreemium && (
				<Banner
					image={require("../../assets/img/tabler.png")}
					title={"How prepared is your organisation?"}
					body1={"The best way to find out is by taking the Crisis Framework assessment."}
					body2={
						"In just 15 minutes, you’ll get a baseline of your current capabilities across People, Communication, Tools, and Organisation — and a clear action plan on what to improve."
					}
					body3={"It’s quick, insightful, and designed to help your team focus where it matters most."}
					onRemind={() => {
						setShowBanner(false)
						setRemindClick(true)
					}}
					onStart={() => {
						navigate(`/tmsWelcome`)
					}}
				/>
			)}
			<h1 className='dashboard__header'>Dashboard</h1>
			<TmsDashboard customerId={customerId} onRemind={remindClick} />
			{!!(customer.Id === customerId) && (
				<section className='card__wrapper'>
					<div className='card-container dashboard__card goal-card'>
						<div className='goal-text-seg'>
							<div>
								<p>{translations.currentgoal}:</p>
								{dashboard.GoalLevel ? (
									<div className='goal-text-card'>
										{translations.tmsLevel + " " + dashboard.GoalLevel} &nbsp;
										{/**
										<IconContext.Provider value={{className: "btn-icon"}}>
											<TbEdit />
										</IconContext.Provider>
									**/}
									</div>
								) : (
									<div className='goal-text-card'>
										{translations.notSet} &nbsp;
										{/**
										<IconContext.Provider value={{className: "btn-icon"}}>
											<TbEdit />
										</IconContext.Provider>
									**/}
									</div>
								)}
							</div>
							{/** <div className='capacity-btn-seg'>
								<Button
									buttonSize={"btn--medium"}
									isLightButton={true}
									onClick={() => navigate(`/tmsWelcome`)}
								>
									{translations.start}
								</Button>
							</div>**/}
						</div>
						<div className='circle-wrapper'>
							<CircleProgress percent={percent} />
						</div>
					</div>
					<div className='card-container dashboard__card capacity-card'>
						<div>
							<h4>{translations.capacityReport}</h4>
							<p>{translations.capacityReportSubtext}</p>
						</div>
						<div className='capacity-btn-seg cap-btn'>
							<Button
								buttonSize={"btn--medium"}
								isLightButton={true}
								onClick={() => navigate(`/tmsassessmentresult`)}
							>
								{translations.capacityReportView}
							</Button>
							<IconContext.Provider value={{className: "btn-icon"}}>
								<CiFileOn />
							</IconContext.Provider>
						</div>
					</div>
					<div className='card-container dashboard__card capacity-card'>
						<div>
							<h4>{translations.capacityQuestionnaire}</h4>
							<p>{translations.capacitySubtext}</p>
						</div>
						<div className='capacity-btn-seg cap-btn'>
							<Button
								buttonSize={"btn--medium"}
								isLightButton={true}
								onClick={() => navigate(`/tmsWelcome`)}
							>
								{translations.start}
							</Button>
							<IconContext.Provider value={{className: "btn-icon"}}>
								<FaQuestion />
							</IconContext.Provider>
						</div>
					</div>
				</section>
			)}
		</ComponentWrapper>
	)
}

export default tmsStartPage
